export default "__VITE_ASSET__PAqxt3nx__"